import { CircularProgress, Grid } from '@mui/material';

const CircularLoading = () => (
  <Grid
    sx={{
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <CircularProgress size={100} color="primary" />
  </Grid>
);

export default CircularLoading;
